import React from 'react';

import ProductCardSkeleton from '../../styled-components/components/ProductCard/ProductCardSkeleton';
import { ProductGrid, ProductGridItem } from '../../styled-components/components/ProductGrid';

interface PlaceholderResultSetProps {
  size: number;
}

const PlaceholderResultSet = ({ size }: PlaceholderResultSetProps) => (
  <ProductGrid>
    {Array.from({ length: size }).map((_, index) => (
      <ProductGridItem key={`skeleton-${index}`}>
        <ProductCardSkeleton />
      </ProductGridItem>
    ))}
  </ProductGrid>
);

export default PlaceholderResultSet;
